import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { useQuery } from "react-query";
import DataFileImportDataService from "../../services/data-file-import-data-service/DataFileImportDataService";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export type UseOrganizationObjectsParams = {
    groupID: number,
    objectType: eLynxObjectTypeEnum
} & BaseUseQueryParameters<IeLynxObject[] | undefined>;

export function useOrganizationObjects({
    groupID,
    objectType,
    enabled,    
    onSuccess,
    onError
}: UseOrganizationObjectsParams) {
    return useQuery<IeLynxObject[], RestError>(
        keys.organizationObjects(groupID, objectType),
        ({ signal }) => {
            return DataFileImportDataService.getOrganizationObjects(
                groupID,
                objectType,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            // refetchInterval: false,
            // staleTime: Infinity,
            // refetchOnWindowFocus: false,
            // refetchOnMount: true,
            // refetchOnReconnect: false,
            // retry: false,
        }
    );
}